/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { isMobile } from "react-device-detect";
// import $ from "jquery";

import "../../css/event211217.css";

class Event20211220_wheel extends Component {
  _map = () => {
    window.open(
      "https://map.naver.com/v5/search/%EC%84%9C%EB%A9%B4%EC%82%BC%EC%A0%95%ED%83%80%EC%9B%8C/place/1466615557?c=14366378.9519615,4184695.3890578,15,0,0,0,dh&placePath=%3Fentry%253Dbmp",
      "",
      ""
    );
  };
  render() {
    return (
      <Fragment>
        <div className="event_head">
          <h3>12월 24일! 부산점 인터렉티브존 룰렛 이벤트 오픈!</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>

        <div className="eventCon">
          <div className="event211217 busan">
            <div className="main">
              <div className="roulette pin">
                <img src="/img/event/event211217_busan/roulette_pin.png" />
              </div>
              <div className="roulette pen">
                <img src="/img/event/event211217_busan/roulette_pan.png" />
              </div>
              <img
                src="/img/event/event211217_busan/top_bg.png"
                alt="12월 24일!  부산점 인터렉티브존 룰렛 이벤트 오픈!"
                className="img_web"
              />
              <img
                src="/img/event/event211217_busan/m_top_bg.png"
                alt="12월 24일!  부산점 인터렉티브존 룰렛 이벤트 오픈!"
                className="img_m"
              />
            </div>
            <div className="btm">
              <img
                src="/img/event/event211217_busan/img01.png"
                alt="럭키 룰렛 돌리고 경품 받자!"
                className="img_web"
              />
              <img
                src="/img/event/event211217_busan/m_img01.png"
                alt="럭키 룰렛 돌리고 경품 받자!"
                className="img_m"
              />
              <a onClick={this._map} style={{ cursor: "pointer" }}>
                <img
                  src="/img/event/event211217_busan/location_tit.png"
                  alt="부산점 오시는길 바로가기"
                  className="img_web"
                />
              </a>
              <a onClick={this._map} style={{ cursor: "pointer" }}>
                <img
                  src="/img/event/event211217_busan/m_location_tit.png"
                  alt="부산점 오시는길 바로가기"
                  className="img_m"
                />
              </a>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event20211220_wheel));
